// extracted by mini-css-extract-plugin
export default {"root":"_1AKCxaODv7rZ11ThIPksz6","submitBtn":"_16qTJc-NRhG9LrIy90-6io","upload":"_14ERYqNx2j9oO0EVsUvMaU","heading":"_1rDoB3s3wFT12D85tr0HqH"};